import { createFileRoute, redirect } from "@tanstack/react-router";

/** The studio page lived here before it became the home page. */
export const Route = createFileRoute("/studio")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
});
